import React from 'react';
import { useTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import {
  AppSettingsStateViewModel,
  api,
  AppSettingsLanguageAction,
  AppSettingsHtmlDirectionAction,
} from 'alg-ecom-frontend-core';
import { State } from 'store/interfaces';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams, useRouteMatch } from 'react-router-dom';

interface CustomProps {
  appSettingsState: AppSettingsStateViewModel;
}

const Footer: React.FunctionComponent<CustomProps> = (props: CustomProps) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { url } = useRouteMatch();
  const { lang } = useParams<{
    lang: string;
  }>();
  const history = useHistory();

  const handleLanguage = async (lng: string) => {
    if (
      props?.appSettingsState?.data &&
      props?.appSettingsState?.data?.languagesList?.length > 0
    ) {
      const data = props?.appSettingsState?.data?.languagesList.find(
        (item) => item.languageLcidstring === lng
      );
      if (data) {
        await api.setLanguageID(data.languageID);
        await dispatch(AppSettingsLanguageAction(data.languageID));
        await dispatch(
          AppSettingsHtmlDirectionAction(lng === 'en' ? 'ltr' : 'rtl')
        );
        // if(lng)
        const urlSplit = url.split('/');
        if (urlSplit.length > 0 && urlSplit[1] === lang) {
          history.replace({
            pathname: url.replace(lang, lng),
          });
          window.location.reload();
        }
      }
    }
  };
  return (
    <>
      <footer className="d-lg-block d-none">
        <div className="footer-top border-top py-4">
          <div className="container py-3">
            <div className="row">
              <div className="col-12 font-xxl d-flex align-items-center">
                <a
                  target="blank"
                  href="https://www.facebook.com/CadillacAlghanim"
                  className="mr-sm-5 mr-4 pr-sm-4 pr-3"
                >
                  <i className="icon-facebook"></i>
                </a>
                <a
                  target="blank"
                  href="https://twitter.com/CadillacKW/?lang=en"
                  className="mr-sm-5 mr-4 pr-sm-4 pr-3"
                >
                  <i className="icon-twitter"></i>
                </a>
                <a
                  target="blank"
                  href="https://www.youtube.com/channel/UC8ZBbEU8vbMk1f7PJMPXtiw"
                  className="mr-sm-5 mr-4 pr-sm-4 pr-3"
                >
                  <i className="icon-youtube"></i>
                </a>
                <a
                  target="blank"
                  href="https://www.instagram.com/cadillacalghanim/"
                  className=""
                >
                  <i className="icon-instagram"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="footer-bottom border-top py-4">
          <div className="container py-2">
            <div className="row align-items-end">
              <div className="col-sm-6 col-12 font-sm">
                <div className="font-weight-bold text-uppercase mb-4">
                  &copy; {t('footer.Alghanim Automotive')}
                </div>
                <div className="d-flex">
                  <a
                    href={
                      i18n.language === 'ar'
                        ? 'https://ar.cadillacalghanim.com/site/privacy-and-legal/'
                        : 'https://www.cadillacalghanim.com/site/privacy-and-legal/'
                    }
                    target="blank"
                    className=""
                  >
                    {t('footer.privacy')}
                  </a>
                  <span className="px-2">|</span>
                  <a
                    href="https://www.cadillacalghanim.com/sitemap/"
                    target="blank"
                    className=""
                  >
                    {t('footer.sitemap')}
                  </a>
                  <span className="px-2">|</span>
                  {i18n.languages[0] !== 'ar' && (
                    <a
                      href="javascript:void(0)"
                      className="text-arabic"
                      onClick={() => handleLanguage('ar')}
                    >
                      عربى
                    </a>
                  )}
                  {i18n.languages[0] !== 'en' && (
                    <a
                      href="javascript:void(0)"
                      className=""
                      onClick={() => handleLanguage('en')}
                    >
                      English
                    </a>
                  )}
                </div>
              </div>
              <div className="col-sm-6 col-12 text-right pb-2">
                <div
                  className="d-inline-flex align-items-center font-xs text-uppercase cursor-pointer"
                  onClick={() => window.scrollTo(0, 0)}
                >
                  {t('footer.back_to_top')}
                  <i className="icon-chevron-up ml-1"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

const mapActionsToProps = (dispatch: any) => {
  return bindActionCreators(
    {
      dispatch,
    },
    dispatch
  );
};

const mapStateToProps = (state: State) => {
  return {
    appSettingsState: state.appSettingsState,
  };
};

export default connect(mapStateToProps, mapActionsToProps)(Footer);
